import moment from "moment";

export function formatMissingHours(hours) {
  const numericHours = Number(hours);
  return Number.isInteger(numericHours)
    ? numericHours.toString()
    : numericHours.toFixed(2);
}

export function getMissingWorklogDialogOpen(responseData = []) {
  return Boolean(responseData?.length);
}

export function getMissingWorklogDayName(date) {
  return new Date(date).toLocaleDateString("en-US", { weekday: "short" });
}

export function getMissingWorklogHours(dailyWorklogHours, spentHours) {
  return dailyWorklogHours - (spentHours || 0);
}

export function formatMissingWorklogLabel(worklogDate, missingHours) {
  const dayName = getMissingWorklogDayName(worklogDate);
  return `${dayName} ${moment(worklogDate).format("MMM DD, YYYY")} (${formatMissingHours(
    missingHours
  )} hrs)`;
}

export function createMissingWorklogPayload({
  currentUser,
  date,
  formData,
}) {
  return {
    user_id: currentUser.user_id,
    leave_date: date,
    ...formData,
  };
}

export function getLeaveTypeOptions() {
  return [
    { value: "Weekend", label: "Weekend" },
    { value: "Holiday", label: "Company Holiday" },
    { value: "Personal Leave", label: "Personal Leave" },
  ];
}
